export default __webpack_public_path__ + "static/media/bscscan-logo-light.9c9f300a.svg";